import React, { useState } from 'react';

import ControlDrawer from './ControlDrawer';

import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import * as classes from './BuilderHeader.module.css';

const FaultControlHeader = ({
    connectorsClicked,
    ...props
}) => {

    const [controlDrawerOpen, setControlDrawerOpen] = useState(false);
    const [controlAnchorEl, setControlAnchorEl] = useState(null);

    const controlOpen = Boolean(controlAnchorEl);
    const controlId = controlOpen ? 'control-nav-select-popover' : undefined;

    const handleControlDrawerClose = () => {
        setControlDrawerOpen(false);
        setControlAnchorEl(null);
    };

    const handleOpenControlDrawer = event => {
        setControlDrawerOpen(true);
        setControlAnchorEl(event.currentTarget);
    };

    return (
        <div style={props.mode === 'template' ? { marginLeft: 0 } : {}} className={classes.OperatorJoin}>
            <ClickAwayListener onClickAway={handleControlDrawerClose}>
                <div style={{ marginLeft: 15 }}>
                    <button
                        className={controlDrawerOpen ? classes.ControlDrawerActive : classes.ControlDrawer}
                        onClick={handleOpenControlDrawer}
                    >
                        Control
                        <i className={`fas fa-chevron-${controlDrawerOpen ? 'down' : 'up'}`} style={{ 'font-size': '12px', 'paddingLeft': '25px' }} aria-hidden="true" />
                    </button>
                    <Popper
                        placement="bottom-start"
                        id={controlId}
                        open={controlDrawerOpen}
                        anchorEl={controlAnchorEl}
                        onClose={handleControlDrawerClose}
                    >
                        <ControlDrawer connectorsClicked={connectorsClicked} />
                    </Popper>
                </div>
            </ClickAwayListener>
            <div
                role="none"
                style={{ marginLeft: 15 }}
                className={classes.SquareIcon}
                onClick={connectorsClicked}
            >
                <button>VARIABLE</button>
            </div>
            <div role="none" className={classes.SquareIcon} onClick={connectorsClicked}>
                <button>CONSTANT</button>
            </div>
        </div>
    );
};

export default FaultControlHeader;
